import { Service } from 'types';
import { baseQuery } from '../baseQuery';

type PartsOnlyServiceParams = {
  customerId: number;
  technicianId: number;
  technicianNote: string;
  description: string;
  serviceType: 'N' | 'C' | 'T';
};

export const postPartsOnlyService = async ({
  customerId,
  technicianId,
  technicianNote,
  description,
  serviceType,
}: PartsOnlyServiceParams) => {
  const { data } = await baseQuery('parts-only-service', {
    type: 'POST',
    body: {
      customer_id: customerId,
      technician_id: technicianId,
      technician_note: technicianNote,
      description,
      job_service_type: serviceType,
    },
  });

  return data as Service;
};
